import { MessageCircle, Facebook } from "lucide-react";
import { waLink, messengerLink } from "@/config/site";

export const FloatingButtons = () => (
  <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3" data-testid="floating-buttons">
    <a
      href={messengerLink}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-messenger-button"
      aria-label="Message us on Facebook Messenger"
      className="w-14 h-14 rounded-full bg-[#0084FF] flex items-center justify-center shadow-[0_8px_30px_rgba(0,132,255,0.4)] hover:scale-110 transition-transform duration-300"
    >
      <Facebook size={24} className="text-white" fill="white" />
    </a>
    <a
      href={waLink("Hi MetalMuse! I'd like to order a metal print.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat with us on WhatsApp"
      className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform duration-300"
    >
      <MessageCircle size={26} className="text-white" fill="white" />
    </a>
  </div>
);
